/**
 * Offer popup: opens after a short delay (or when the shopper moves to leave on desktop),
 * runs a live countdown to the offer end, copies the code, and stays closed for 24 hours
 * after it is dismissed. Hides itself the moment the offer ends.
 */
const root = document.querySelector('[data-k-promo]');

if (root) {
  const STORAGE_KEY = `k-promo-closed-${root.dataset.code}`;
  const SNOOZE_MS = 24 * 60 * 60 * 1000;
  const end = Date.parse(root.dataset.ends);
  const delay = Math.max(2, Number(root.dataset.delay) || 6) * 1000;
  const card = root.querySelector('[role="dialog"]');
  const fields = {
    d: root.querySelector('[data-k-d]'),
    h: root.querySelector('[data-k-h]'),
    m: root.querySelector('[data-k-m]'),
    s: root.querySelector('[data-k-s]'),
  };
  let timer = null;
  let lastFocus = null;
  let opened = false;

  const snoozed = () => {
    try {
      const at = Number(localStorage.getItem(STORAGE_KEY));
      return at && Date.now() - at < SNOOZE_MS;
    } catch {
      return false;
    }
  };

  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => {
    const left = end - Date.now();
    if (!Number.isFinite(end) || left <= 0) {
      close(false);
      root.remove();
      return false;
    }
    const sec = Math.floor(left / 1000);
    fields.d.textContent = pad(Math.floor(sec / 86400));
    fields.h.textContent = pad(Math.floor((sec % 86400) / 3600));
    fields.m.textContent = pad(Math.floor((sec % 3600) / 60));
    fields.s.textContent = pad(sec % 60);
    return true;
  };

  const onKey = (event) => {
    if (event.key === 'Escape') close(true);
  };

  function open() {
    if (opened || snoozed() || !tick()) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-open'));
    timer = setInterval(tick, 1000);
    document.addEventListener('keydown', onKey);
    card.querySelector('.k-promo__cta')?.focus({ preventScroll: true });
  }

  function close(remember) {
    if (remember) {
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch {
        /* storage unavailable: the popup simply may show again */
      }
    }
    clearInterval(timer);
    document.removeEventListener('keydown', onKey);
    root.classList.remove('is-open');
    setTimeout(() => {
      root.hidden = true;
    }, 300);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  root.querySelectorAll('[data-k-promo-close]').forEach((el) => el.addEventListener('click', () => close(true)));
  root.querySelector('.k-promo__cta')?.addEventListener('click', () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      /* ignore */
    }
  });

  const copyBtn = root.querySelector('[data-k-promo-copy]');
  const hint = root.querySelector('[data-k-promo-copy-hint]');
  copyBtn?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(root.dataset.code);
      hint.textContent = 'Copied!';
    } catch {
      hint.textContent = 'Copy it manually';
    }
    setTimeout(() => {
      hint.textContent = 'Tap to copy';
    }, 2000);
  });

  if (!snoozed() && tick()) {
    setTimeout(open, delay);
    // Desktop exit intent: the pointer leaves through the top of the window.
    document.addEventListener('mouseout', (event) => {
      if (!event.relatedTarget && event.clientY <= 0) open();
    });
  }
}
